
import { ROUTES } from '~~/constants/routes';
import { BRAND_REFINEMENT_LIST } from '~~/constants/typesense';
import type { BrandInfo } from '~~/constants/brands';

export const useBrandPage = () => {

  const { getAdjustedSlug } = useRouteExtended();
  const { addPrefixToSlugIfNecessary } = usePrefix();

  const getBrandFilter = (brandNames: string[]) => {

    return brandNames.map((name, index) => {

      const nameEncoded = encodeURIComponent(name);

      return `${BRAND_REFINEMENT_LIST}[${index}]=${nameEncoded}`;

    }).join('&');

  };

  const getBrandSearchPageUrl = (brand: BrandInfo, withSubBrands: boolean = false): string => {

    if (!brand?.name) {

      return '';

    }

    const filter = withSubBrands && brand.subBrands?.length
      ? getBrandFilter(brand.subBrands)
      : getBrandFilter([brand.name]);

    return `${getAdjustedSlug(ROUTES.SEARCH)}?${filter}`;

  };

  const getBrandInternalPageUrl = (brand: BrandInfo): string => {

    if (!brand?.internalUrl) {

      return '';

    }

    return addPrefixToSlugIfNecessary(brand.internalUrl);

  };

  return {
    getBrandSearchPageUrl,
    getBrandInternalPageUrl,
  };

};
